/**
 * Application configuration
 * Centralizes all environment variables and configuration settings
 *
 * Uses runtime configuration (window.APP_CONFIG) when available,
 * falling back to build-time environment variables for development.
 */

interface AppConfig {
  // API Configuration
  apiBaseUrl: string;
  apiTimeout: number;

  // Feature flags
  isDevelopment: boolean;
  isProduction: boolean;

  // Application settings
  appName: string;
  version: string;
}

/**
 * Get configuration value with runtime override support
 * Priority: window.APP_CONFIG > import.meta.env > default
 */
function getConfigValue(
  runtimeKey: keyof RuntimeConfig,
  envKey: string,
  defaultValue: string
): string {
  // Check runtime config first (for production)
  const runtime = typeof window !== 'undefined' ? window.APP_CONFIG?.[runtimeKey] : undefined;
  if (typeof runtime === 'string' && runtime) {
    return runtime;
  }
  // Fall back to build-time env var (for development)
  return import.meta.env[envKey] || defaultValue;
}

// Get environment variables with defaults
const config: AppConfig = {
  // API Configuration
  apiBaseUrl: getConfigValue('API_BASE_URL', 'VITE_API_BASE_URL', 'http://localhost:5001'),
  apiTimeout: parseInt(import.meta.env.VITE_API_TIMEOUT || '30000'),

  // Feature flags
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,

  // Application settings
  appName: getConfigValue('APP_NAME', 'VITE_APP_NAME', 'Balance Sheet Signoff'),
  version: '1.0.0',
};

// Log configuration in development
// if (config.isDevelopment) {
//   console.log('App Configuration:', {
//     apiBaseUrl: config.apiBaseUrl,
//     apiTimeout: config.apiTimeout,
//     isDevelopment: config.isDevelopment,
//   });
// }

// Export individual values for backward compatibility
export const API_BASE_URL = config.apiBaseUrl;

export default config;